import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { changeDateFormate, datetimeToDate } from '../../../utils/dateFormat';
import CoachingToDo from '../../../components/CoachingToDo/CoachingToDo';
import { useCoachingGoalReviewMutation } from '../goals/goalSlice';
import './revgen.scss';
import CoachingShoutOut from '../../../components/coachingShoutOut/coachingShoutOUt';
import { selectCurrentEmpid } from '../../../pages/login/authSlice';
import DescriptionBox from '../../../components/descriptionBox/DescriptionBox';

interface RevgenGoalSettingProps {
    data: any;
    recipientDetails: any;
    setExpandedRows: (params: any) => void;
    hideControls: boolean;
}

export const RevgenGoalReview = ({
    data,
    recipientDetails,
    setExpandedRows,
    hideControls,
}: RevgenGoalSettingProps) => {
    const [tlFeedback, setTLFeedback] = useState<string>('');
    const [assocMonthEndComments, setAssocMonthEndComments] = useState<string>('');
    const [todoVisible, setTodoVisible] = useState(false);
    const [shoutoutVisible, setShoutoutVisible] = useState(false);
    const [CoachingGoalReview] = useCoachingGoalReviewMutation();
    const [actualPayout, setActualPayout] = useState<string>('');
    const loggedEmpNum = useSelector(selectCurrentEmpid);

    useEffect(() => {
        setTLFeedback(data?.author_month_end_review_comment || '');
        setAssocMonthEndComments(data?.response_month_end_review_comment || '');
        setActualPayout(data?.actual_goal_value || '');
    }, []);

    const handleSave = () => {
        const payload: any = {
            coachingGoalId: data?.coaching_goal_id,
            authorMonthEndReviewComment: tlFeedback,
            responseMonthEndReviewComment: assocMonthEndComments,
            actualGoalValue: actualPayout ? actualPayout.toString() : '',
        };
        if (
            data?.author_month_end_review_comment !== (tlFeedback === '' ? null : tlFeedback) ||
            data?.actual_goal_value !== (actualPayout === '' ? null : actualPayout)
        ) {
            payload.authorReviewDate = datetimeToDate(Date.now());
        }
        if (
            data?.response_month_end_review_comment !==
            (assocMonthEndComments === '' ? null : assocMonthEndComments)
        ) {
            payload.responseReviewDate = datetimeToDate(Date.now());
        }
        CoachingGoalReview(payload)
        .unwrap()
        .then((res: any) => {
            if (res?.data) toast.success('Goal Review Saved Successfully');
            else toast.error('Failed to save goal review');
        })
        .catch(() => {
            toast.error('Failed to save goal review');
        });
    };

    return (
        <>
            <div className="align-center d-flex justify-content-between mt-2">
                <h6 className="color-green">Supervisor Feedback</h6>
                <hr className="color-green width-75 border-2" />
                <h6 className="color-green">End of the Month</h6>
            </div>
            <DescriptionBox
                value={tlFeedback}
                responseDescription={tlFeedback}
                readOnly={hideControls || recipientDetails?.employeeNumber === loggedEmpNum}
                limit={1000}
                onChange={(value) => {
                    setTLFeedback(value);
                }}
            />
            <div className="d-flex justify-content-start mt-3">
                <div className="me-4">
                    <h6>Date</h6>
                    <div>
                        {data?.author_review_date !== null
                            ? changeDateFormate(datetimeToDate(data?.author_review_date))
                            : ''}
                    </div>
                </div>
                <div className="me-4">
                    <h6>Author</h6>
                    {data?.author_employee_name}
                </div>
                <div className="me-4">
                    <h6>Actual Results</h6>
                    <InputText
                        // keyfilter="pnum"
                        className="borderRadius8  me-4"
                        value={actualPayout}
                        disabled={hideControls || recipientDetails?.employeeNumber === loggedEmpNum}
                        onChange={(e) => setActualPayout(e.target.value)}
                        maxLength={20}
                    />
                    <div className="d-flex justify-content-end textSmall lightText me-4">{`${actualPayout?.length}/20 character limit`}</div>
                </div>
            </div>
            <div className="align-center d-flex justify-content-between mt-2">
                <h6 className="color-green">Associate Month-End Review Comments</h6>
                <hr className="color-green width-63 border-2" />
                <h6 className="color-green">End of the Month</h6>
            </div>
            <DescriptionBox
                value={assocMonthEndComments}
                responseDescription={assocMonthEndComments}
                readOnly={hideControls || recipientDetails?.employeeNumber !== loggedEmpNum}
                limit={1000}
                onChange={(value) => {
                    setAssocMonthEndComments(value);
                }}
            />
            <div className="d-flex justify-content-start mt-3">
                <div className="me-4">
                    <h6>Date</h6>
                    <div>
                        {data?.response_review_date !== null
                            ? changeDateFormate(datetimeToDate(data?.response_review_date))
                            : ''}
                    </div>
                </div>
            </div>
            <div className="float-end mt-2">
                <div
                    className="col-md-5"
                    style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}
                >
                    <Button
                        label="Cancel"
                        // style={{ fontWeight: 400 }}
                        className="btn-secondary me-2"
                        onClick={() => {
                            setExpandedRows(null);
                        }}
                    />

                    <Button label="Save" disabled={hideControls} onClick={handleSave} className="btn-primary me-2" />
                    <CoachingToDo
                        receiverId={recipientDetails.employee_number}
                        receiverName={recipientDetails.employee_name}
                        visible={todoVisible}
                        setVisible={setTodoVisible}
                        coachingEntityTypeId={5}
                        coachingEntityId={data.coaching_goal_id}
                        coachingStatusId={1}
                    />
                    <CoachingShoutOut
                        receiverId={recipientDetails.employee_number}
                        receiverName={recipientDetails.employee_name}
                        visible={shoutoutVisible}
                        setVisible={setShoutoutVisible}
                        coachingEntityTypeId={5}
                        coachingEntityId={data.coaching_goal_id}
                        coreValueId={0}
                    />
                </div>
            </div>
        </>
    );
};
